module.exports = __webpack_public_path__ + "static/img/txbc.dcf75eb2.png";